'use client';

const ColorsSection = () => {
  return (
    <section className="my-12">
      {/* Title Section */}
      <h1 className="text-2xl sm:text-3xl xl:text-4xl text-[--accent-light] my-4">
        Colors
      </h1>

      <p className="text-xl font-bold mb-2 mx-6">
        Bringing Centera Tech To Life
      </p>

      {/* Color Palette Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mt-6 sm:mt-8 mx-6">
        {[
          { name: "Accent Light", hex: "#96ea63", rgb: "150 234 99" },
          {
            name: "Accent Transparent 1",
            hex: "#96ea6388",
            rgb: "150 234 99, 0.53",
          },
          {
            name: "Accent Transparent 2",
            hex: "#97ea631c",
            rgb: "151 234 99, 0.11",
          },
          { name: "Accent Dark", hex: "#43841c", rgb: "67 132 28" },
          { name: "Accent Darkest", hex: "#0e1d04", rgb: "14 29 4" },
          { name: "Primary Text", hex: "#ffffff", rgb: "255 255 255" },
          { name: "Secondary Text", hex: "#a7a7a7", rgb: "167 167 167" },
          { name: "Neutral BG", hex: "#777777", rgb: "119 119 119" },
          { name: "Tertiary BG", hex: "#2d2d2f", rgb: "45 45 47" },
          { name: "Secondary BG 3", hex: "#1d1d1d", rgb: "29 29 29" },
          { name: "Secondary BG 2", hex: "#141414", rgb: "20 20 20" },
          { name: "Secondary BG", hex: "#0b0b10", rgb: "11 11 16" },
          { name: "Primary BG", hex: "#09090b", rgb: "9 9 11" },
          { name: "Primary BG 2", hex: "#000000", rgb: "0 0 0" },
          {
            name: "BG Transparent 1",
            hex: "#000000dd",
            rgb: "0 0 0, 0.87",
          },
          {
            name: "BG Transparent 2",
            hex: "#0f0f0ff4",
            rgb: "15 15 15, 0.96",
          },
          {
            name: "BG Transparent 3",
            hex: "#0d0d0dad",
            rgb: "13 13 13, 0.68",
          },
        ].map((color, index) => (
          <div key={index} className="flex items-center gap-4">
            <div
              className="w-16 h-16 sm:w-20 sm:h-20 rounded-full border border-color-97"
              style={{ backgroundColor: color.hex }}
            ></div>
            <div>
              <h3 className="sm:text-xl font-bold">{color.name}</h3>
              <p className="text-color-2">RGB - {color.rgb}</p>
              <p className="text-color-2">HEX - {color.hex}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ColorsSection;
